(() => {
  if (customElements.get('rideout-video-story')) return;

  class RideoutVideoStory extends HTMLElement {
    constructor() {
      super();
      this.onIntersect = this.onIntersect.bind(this);
      this.onPlaying = this.onPlaying.bind(this);
      this.onSoundClick = this.onSoundClick.bind(this);
      this.isNear = false;
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.soundButton = this.querySelector('[data-rideout-video-sound]');
      if (!this.video) return;

      this.video.muted = true;
      this.video.playsInline = true;
      this.autoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.video.addEventListener('playing', this.onPlaying);
      this.soundButton?.addEventListener('click', this.onSoundClick);

      this.observer = new IntersectionObserver(this.onIntersect, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.removeEventListener('playing', this.onPlaying);
      this.soundButton?.removeEventListener('click', this.onSoundClick);
    }

    onIntersect(entries) {
      this.isNear = entries.some((entry) => entry.isIntersecting);
      if (this.isNear && (this.autoplay || !this.video.muted)) {
        this.play();
      } else if (!this.isNear) {
        this.video.pause();
      }
    }

    onPlaying() {
      this.classList.add('is-playing');
    }

    onSoundClick() {
      const unmute = this.video.muted;
      this.video.muted = !unmute;
      this.classList.toggle('is-unmuted', unmute);
      this.soundButton.setAttribute('aria-pressed', String(unmute));
      if (unmute && this.video.paused) this.play();
    }

    play() {
      const promise = this.video.play();
      // Browsers may reject autoplay (e.g. low-power mode); the poster stays visible then.
      promise?.catch(() => {});
    }
  }

  customElements.define('rideout-video-story', RideoutVideoStory);
})();
